import { ApiService } from '../../services/api_service';
import { DatenauswertungFormWrapper } from './DatenauswertungFormWrapper';
import { DatenauswertungGenerisch } from './DatenauswertungGenerisch';
import { DatenauswertungJahrauswahl } from './DatenauswertungJahrauswahl';
import { DatenauswertungReportKonfigurationBemerkungButton } from './DatenauswertungReportKonfigurationBemerkungButton';
import datenauswertungStyle from './datenauswertung.less'
import { fn2, fn2nZ } from '../../core/formatter/formatNumber';
import {
    getCO2Scope3StructureAllgemein, getCO2Scope3StructureNachgelagert, getCO2Scope3StructureVorgelagert
} from '../dateneingabe/functions/getCO2Scope3Structure';
import { getRoutingCO2Scope3 } from '../../helpers/getRoutingCO2Scope3';
import { getStandorteGruppenTabRoutings } from '../dateneingabe/functions/StandorteGruppen';
import { getStyle } from './generisch/DatanauswertungGenerischStyles';
import { i18n } from '../../i18n/i18n';
import { IDs } from '../../helpers/IDs';
import { isVeranstaltung } from '../../helpers/getVeranstaltungen';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { rowHasValues } from './generisch/renderRows';
import { SectionStyle } from '../../helpers/SectionStyle';
import { StandortAuswahl } from './elements/StandortAuswahl';
import { Validierung } from './elements/Validierung';
import { ValidierungHinweise } from './elements/ValidierungHinweise';
import { WActionButton } from '../../core/elements/WActionButton';
import { WHelpIcon } from '../../core/elements/WHelpIcon';

interface DatenauswertungCO2FussabdruckProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    standortTid: number;
    standortName: string;
    routing: any;
    jahrFirst?: number;
    jahrLast?: number;
    setJSXdirect?: (content: JSX.Element) => void;
    callbackPages?: (pageNumber: number, totalPages: number) => void;
    pdfLayoutless?: boolean;
    id?: string;
}

interface DatenauswertungCO2FussabdruckState {
    pdfString?: string;
    firstJahr: number;
    lastJahr: number;
    jahrMin: number;
    jahrMax: number;
    renderButton: JSX.Element;
    validation: any;
}

export class DatenauswertungCO2Fussabdruck extends React.Component<DatenauswertungCO2FussabdruckProps, DatenauswertungCO2FussabdruckState> {

    constructor(props: any) {
        super(props);
        const data: any = props.data || {};
        const startjahr: number = ((data[IDs.ENT_KONFIGURATION] || [])[0] || {}).startjahr_datenerfassung || null;
        const jahrMax: number = new Date().getFullYear();
        let jahrMin: number = (data.first_year > 2009 && data.first_year < 2015) ? data.first_year : 2015;
        jahrMin = (startjahr > jahrMin) ? startjahr : jahrMin;
        this.state = {
            lastJahr: this.props.jahrLast || jahrMax - 1,
            firstJahr: this.props.jahrFirst || jahrMin,
            jahrMin: jahrMin,
            jahrMax: jahrMax,
            renderButton: undefined,
            validation: {}
        };
    }

    @lazyInject(ApiService) private apiService: ApiService;

    private entities: any[] = [
        // { titel: 'Technische Gase/Kältemittel', entity: IDs.ENT_KLIMAGASE }
    ];

    componentDidMount(): void {
        const bereichKey = this.apiService.getBereichKey();
        const modul: string = (this.props.data || {}).MODUL_SELECTED || null;
        [
            ...getCO2Scope3StructureVorgelagert(bereichKey, modul) || [],
            ...getCO2Scope3StructureNachgelagert(bereichKey, modul) || [],
            ...getCO2Scope3StructureAllgemein() || []
        ].forEach((entity: any) => {
            if (!entity.ignore && entity.key && entity.name) {
                this.entities.push({ titel: i18n(entity.name, 'sys'), entity: `co2_scope3_${entity.key}` });
            }
        });
        this.setState({
            validation: new Validierung(
                this.props.data,
                this.props.standortTid,
                this.entities,
                'jahr'
            ).getData()
        });
    }

    getValues(): any {
        const konfiguration: any[] = this.props.data[IDs.ENT_KONFIGURATION] || [];
        const disabledCO2Komplex: boolean = !IDs.FLAG_ENABLE_SCOPE3
            || !konfiguration.some((param: any) => param.co2_fussabdruck_orig === 1);
        const rows: any[] = [];
        const diag1: any[] = [];
        const diag2: any[] = [];
        const custom_row_classes: any[] = [];
        const row_web_forced: boolean[] = [];
        const kennzahlen = this.props.standortTid
            ? this.props.data[IDs.KENNZIFFERN_BERECHNET_STANDORT][this.props.standortTid]
            : this.props.data[IDs.KENNZIFFERN_BERECHNET];

        for (let jahr = this.state.firstJahr; jahr <= this.state.lastJahr; jahr++) {
            const kz: any = kennzahlen[jahr] || {};
            const row = [
                jahr,
                fn2(kz.co2_fussabdruck_scope1), fn2(kz.co2_fussabdruck_scope1_anteil),
                fn2(kz.co2_fussabdruck_scope2), fn2(kz.co2_fussabdruck_scope2_anteil),
                fn2(kz.co2_fussabdruck_scope3), fn2(kz.co2_fussabdruck_scope3_anteil),
                fn2(kz.co2_fussabdruck_total),
                fn2(kz.co2_fussabdruck_ma), fn2(kz.co2_fussabdruck_umsatz),
                fn2nZ(kz.co2_fussabdruck_scope_oos)
            ];
            if (disabledCO2Komplex) {
                row.splice(10, 1);
                row.splice(5, 2);
            }
            const row_length: number = row.length;
            const hasValues: boolean = rowHasValues(row);
            const isWebForced: boolean = !!(!hasValues && this.state.validation[jahr]);
            const d1 = {
                jahr,
                scope1: kz.co2_fussabdruck_scope1 || kz.co2_fussabdruck_scope1 === 0 ? +(kz.co2_fussabdruck_scope1).toFixed(2) : null,
                scope2: kz.co2_fussabdruck_scope2 || kz.co2_fussabdruck_scope2 === 0 ? +(kz.co2_fussabdruck_scope2).toFixed(2) : null,
                scope3: kz.co2_fussabdruck_scope3 || kz.co2_fussabdruck_scope3 === 0 ? +(kz.co2_fussabdruck_scope3).toFixed(2) : null
            };
            const d2 = {
                jahr,
                scope1: kz.co2_fussabdruck_scope1_anteil || kz.co2_fussabdruck_scope1_anteil === 0
                    ? +(kz.co2_fussabdruck_scope1_anteil).toFixed(2) : null,
                scope2: kz.co2_fussabdruck_scope2_anteil || kz.co2_fussabdruck_scope2_anteil === 0
                    ? +(kz.co2_fussabdruck_scope2_anteil).toFixed(2) : null,
                scope3: kz.co2_fussabdruck_scope3_anteil || kz.co2_fussabdruck_scope3_anteil === 0
                    ? +(kz.co2_fussabdruck_scope3_anteil).toFixed(2) : null,
            };
            // console.log('CO2S3', jahr, d1, d2, kz.co2_fussabdruck_scope2, kz.co2_fussabdruck_scope2_anteil);
            if (!IDs.FLAG_ENABLE_SCOPE3) {
                delete (d1.scope3);
                delete (d2.scope3);
            }
            rows.push([
                <div data-text={row[0]}>
                    <div>{row[0]}</div>
                    {this.state.validation[jahr] &&
                        <ValidierungHinweise
                            entities={this.entities}
                            id={jahr}
                            showPriorityColors
                            validation={this.state.validation}
                        />
                    }
                </div>,
                ...(!hasValues && this.state.validation[jahr]
                    ? Array.from(Array(row_length - 1), (): any => null)
                    : [...Array(row_length - 1)].map((item: any, index: number) => row[index + 1])
                )
            ]);
            if (hasValues) {
                if (kz.co2_fussabdruck_scope1 || kz.co2_fussabdruck_scope1 === 0 || kz.co2_fussabdruck_scope2
                    || kz.co2_fussabdruck_scope2 === 0 || kz.co2_fussabdruck_scope3 || kz.co2_fussabdruck_scope3 === 0) {
                    diag1.push(d1);
                }
                if (kz.co2_fussabdruck_scope1_anteil || kz.co2_fussabdruck_scope1_anteil === 0 || kz.co2_fussabdruck_scope2_anteil
                    || kz.co2_fussabdruck_scope2_anteil === 0 || kz.co2_fussabdruck_scope3_anteil || kz.co2_fussabdruck_scope3_anteil === 0) {
                    diag2.push(d2);
                }
            }
            custom_row_classes.push(isWebForced ? Array.from(Array(row_length), () => 'row_field') : undefined);
            row_web_forced.push(isWebForced);
        }
        return { rows, diag1, diag2, custom_row_classes, row_web_forced };
    }

    render(): JSX.Element {
        const konfiguration: any[] = this.props.data[IDs.ENT_KONFIGURATION] || [];
        const disabledCO2Komplex: boolean = !IDs.FLAG_ENABLE_SCOPE3
            || !konfiguration.some((param: any) => param.co2_fussabdruck_orig === 1);
        const color: any = SectionStyle.getSectionColors() || {};
        const lineColor = [
            color.datenauswertung || '#728a49', color.zusatztools || '#de863f', color.dateneingabe || '#6f91be',
            '#0a0', '#4f81bd', '#f79646', '#51bd75', '#5163bd', '#9951bd', '#bd5175', '#bd5151'
        ];
        // const style: any = { sub: getStyle('sub') };
        const numCols = !disabledCO2Komplex ? 11 : 8; // -3 wg. Scope 3 (inkl. Out-of-Scope) ausgeblendet
        const baseWidth = 100 / numCols; // Bitte immer in Prozent angeben
        const unternehmen: string = ((this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).name
            || (this.props.data.RES_MAIN_LOAD_UNTERNEHMEN_SEL || {}).bezeichnung || null;
        const values = this.getValues();
        const [backgroundColorSection, colorSection] = new SectionStyle().getPropertyValues([
            '--color-section-main', '--color-button-text'
        ]);
        const customStyle = { backgroundColor: backgroundColorSection || '#728A49', color: colorSection || '#fff' };
        // console.log('CSL:', customStyle);
        const config: any = {
            titel0: unternehmen,
            titel1: i18n('Auswertung CO₂-Fußabdruck', 'sys'),
            titel2: this.props.standortName,
            filename: `${i18n('Auswertung', 'sys')}_CO2_${i18n('Fussabdruck', 'sys')}_${this.state.firstJahr}_${this.state.lastJahr}.pdf`,
            report: { data: (this.props.data || {})[IDs.ENT_REPORT] || [], standort: +this.props.standortTid || 0, key: 'co2' },
            baseWidth: baseWidth,
            header: {
                title: i18n('Übersicht Berechnung', 'sys'),
                blocks: [
                    {
                        label: i18n('Jahr', 'sys'),
                        customStyle,
                        width: `${baseWidth * 0.75}%`
                    },
                    {
                        label: `SCOPE 1\n(${i18n('direkte Emissionen - Energie', 'sys')})`,
                        width: `${baseWidth * 2}%`,
                        customStyle,
                        columns: [
                            {
                                label: i18n('Absoluter Anteil', 'sys'), label2: 't CO₂ Äq', customStyleLabel: { ...customStyle },
                                customStyleLabel2: { borderTop: '1pt solid #fff', ...customStyle }
                            },
                            {
                                label: i18n('Relativer Anteil', 'sys'), label2: '%', customStyleLabel: { ...customStyle },
                                customStyleLabel2: { borderTop: '1pt solid #fff', ...customStyle }
                            },
                        ]
                    },
                    {
                        label: `SCOPE 2\n(${i18n('indirekte Emissionen - Energie', 'sys')})`,
                        width: `${baseWidth * 2}%`,
                        customStyle,
                        columns: [
                            {
                                label: i18n('Absoluter Anteil', 'sys'), label2: 't CO₂ Äq', customStyleLabel: { ...customStyle },
                                customStyleLabel2: { borderTop: '1pt solid #fff', ...customStyle }
                            },
                            {
                                label: i18n('Relativer Anteil', 'sys'), label2: '%', customStyleLabel: { ...customStyle },
                                customStyleLabel2: { borderTop: '1pt solid #fff', ...customStyle }
                            },
                        ]
                    },
                    {
                        label: `SCOPE 3\n(${i18n('indirekte Emissionen - Weitere', 'sys')})`,
                        width: `${baseWidth * 2}%`,
                        customStyle,
                        columns: [
                            {
                                label: i18n('Absoluter Anteil', 'sys'), label2: 't CO₂ Äq', customStyleLabel: { ...customStyle },
                                customStyleLabel2: { borderTop: '1pt solid #fff', ...customStyle }
                            },
                            {
                                label: i18n('Relativer Anteil', 'sys'), label2: '%', customStyleLabel: { ...customStyle },
                                customStyleLabel2: { borderTop: '1pt solid #fff', ...customStyle }
                            },
                        ]
                    },
                    {
                        label: i18n('Emissionen{{lb}}GESAMT', 'sys').replace('{{lb}}', '\n'),
                        width: `${baseWidth}%`,
                        customStyle,
                        columns: [
                            {
                                label: i18n('Absoluter Anteil', 'sys'), label2: 't CO₂ Äq', customStyleLabel: { ...customStyle },
                                customStyleLabel2: { borderTop: '1pt solid #fff', ...customStyle }
                            }
                        ]
                    },
                    {
                        label: i18n('Emissions-Kennzahlen', 'sys'),
                        width: `${baseWidth * 2.5}%`,
                        customStyle,
                        columns: [
                            {
                                label: i18n('Emissionen je MA', 'sys'), label2: 't CO₂ Äq / MA', customStyleLabel: { ...customStyle },
                                customStyleLabel2: { borderTop: '1pt solid #fff', ...customStyle }
                            },
                            {
                                label: [
                                    i18n('Emissionen je {{1}}€ Umsatz', 'sys').replace('{{1}}', 1000),
                                    i18n('Emissionen/{{lb}}{{1}}€ Umsatz', 'sys').replace('{{lb}}', '\n').replace('{{1}}', 1000)
                                ],
                                label2: 't CO₂ Äq / T€',
                                customStyleLabel: { ...customStyle }, customStyleLabel2: { borderTop: '1pt solid #fff', ...customStyle }
                            },
                        ]
                    },
                    {
                        label: i18n('Emissionen{{lb}}Out-of-Scope', 'sys').replace('{{lb}}', '\n'),
                        width: `${baseWidth * 0.75}%`,
                        customStyle,
                        columns: [
                            {
                                label: i18n('Absoluter Anteil', 'sys'), label2: 't CO₂ Äq', customStyleLabel: { ...customStyle },
                                customStyleLabel2: { borderTop: '1pt solid #fff', ...customStyle }
                            }
                        ]
                    },
                ]
            },
            rows: values.rows,
            row_classes: [
                'row_field_header_green2', 'row_field_green', 'row_field_green', 'row_field_green', 'row_field_green', 'row_field_green',
                'row_field_green', 'row_field_green', 'row_field_green', 'row_field_green', 'row_field_green'
            ],
            custom_row_classes: values.custom_row_classes,
            row_web_forced: values.row_web_forced,
            rows_width: [baseWidth * 0.75, , , , , , , , baseWidth * 1.25, baseWidth * 1.25, baseWidth * 0.75],
            diagrams: [
                {
                    title: `${i18n('Emissionen je SCOPE in', 'sys')} t CO₂ Äq`,
                    titlePdf: `${i18n('Emissionen je SCOPE in', 'sys')} t CO₂ Äq`,
                    legend: ['Scope 1 [t CO₂ Äq]', 'Scope 2 [t CO₂ Äq]', 'Scope 3 [t CO₂ Äq]'],
                    unit: ['t', 't', 't'],
                    X_dataKey: 'jahr',
                    Y_dataKey: ['scope1', 'scope2', 'scope3'],
                    data: values.diag1,
                    tickPeriod: [50, 50],
                    singleYAxis: true,
                    lineColor,
                    containerSize: { width: '90%' },
                },
                {
                    title: i18n('Prozentuale Verteilung der Emissionen je Scope', 'sys'),
                    titlePdf: i18n('Verbrauchsbedingte CO₂-Emissionen', 'sys'),
                    legend: ['Scope 1 [%]', 'Scope 2 [%]', 'Scope 3 [%]'],
                    unit: ['%', '%', '%'],
                    X_dataKey: 'jahr',
                    Y_dataKey: ['scope1', 'scope2', 'scope3'],
                    data: values.diag2,
                    tickPeriod: [50, 50],
                    singleYAxis: true,
                    lineColor,
                    containerSize: { width: '90%' },
                }
            ]
        };
        if (disabledCO2Komplex) {
            config.header.blocks.splice(6, 1);
            config.header.blocks.splice(3, 1);
            config.rows_width.splice(5, 2);
            config.diagrams[0].legend.splice(2, 1);
            config.diagrams[1].legend.splice(2, 1);
            config.diagrams[0].unit.splice(2, 1);
            config.diagrams[1].unit.splice(2, 1);
            config.diagrams[0].Y_dataKey.splice(2, 1);
            config.diagrams[1].Y_dataKey.splice(2, 1);
        }
        const helpIcon = (
            <WHelpIcon
                data={this.props.data}
                styleDivProps={{ display: 'inline-block' }}
                styleProps={{ width: 18, height: 18, borderRadius: 10, backgroundColor: '#728A49', verticalAlign: 'top', margin: 0 }}
                label={i18n('Datenauswertung - Hinweise', 'sys')}
                helpKey='datenauswertung_co2'
                type='info'
                editBar
            />
        );
        const jahresauswahl: any = <DatenauswertungJahrauswahl
            jahrMin={this.state.jahrMin}
            jahrMax={this.state.jahrMax}
            jahrFirst={this.state.firstJahr}
            jahrLast={this.state.lastJahr}
            contextKey='datenauswertung'
            onFirstJahrChange={(jahr: number) => this.setState({ firstJahr: jahr })}
            onLastJahrChange={(jahr: number) => this.setState({ lastJahr: jahr })}
            renderClean={true}
            wrapClass={datenauswertungStyle.datenauswertungFormField}
        />;
        const arr_header_form_elements: any[] = [
            {
                elem: jahresauswahl,
                wrapClass: 'datenauswertungContentLeft',
                skipFormFieldWrapper: true
            },
            {   elem: isVeranstaltung(this.props.data, this.props.standortTid) ? this.renderVeranstaltung() : this.renderStandort(),
                wrapClass: 'datenauswertungContentGrow'
            },
            { elem: <span className={datenauswertungStyle.datenauswertungArrow}>🡆</span>, wrapClass: 'datenauswertungContentRight' },
            { elem: <><label>{i18n('Optionen', 'sys')}</label>{this.renderEingabeButton()}</>, wrapClass: 'datenauswertungContentRight' },
            { elem: <><label>&nbsp;</label>{this.renderBemerkungButton()}</>, wrapClass: 'datenauswertungContentRight' },
            { elem: <><label>&nbsp;</label>{this.state.renderButton}</>, wrapClass: 'datenauswertungContentRight' },
        ];

        return (
            <div>
                {!this.props.setJSXdirect &&
                    <div className={datenauswertungStyle.datenauswertungOuterFormContainer}>
                        {/*<DatenauswertungJahrauswahl
                            jahrMin={this.state.jahrMin}
                            jahrMax={this.state.jahrMax}
                            jahrFirst={this.state.firstJahr}
                            jahrLast={this.state.lastJahr}
                            contextKey='datenauswertung'
                            externalHeaderElements={[this.renderEingabeButton(), this.renderBemerkungButton(), this.state.renderButton]}
                            onFirstJahrChange={(jahr: number) => this.setState({ firstJahr: jahr })}
                            onLastJahrChange={(jahr: number) => this.setState({ lastJahr: jahr })}
                        />
                        <div style={{ padding: 5, paddingRight: 20 }}>{helpIcon}</div>
                        */}
                        <DatenauswertungFormWrapper
                            elements={arr_header_form_elements}
                        />
                    </div>
                }
                <DatenauswertungGenerisch
                    id={this.props.id}
                    config={config}
                    orientation='landscape'
                    setRenderButton={(renderButton: JSX.Element) => this.setState({ renderButton })}
                    setJSXdirect={this.props.setJSXdirect}
                    callbackPages={typeof this.props.callbackPages === 'function' ? this.props.callbackPages : null}
                    pdfButtonStyle={{ backgroundColor: '#686868', color: '#fff' }}
                    pdfLayoutless={this.props.pdfLayoutless}
                />
            </div>
        );
    }

    renderBemerkungButton(): JSX.Element {
        return (
            <DatenauswertungReportKonfigurationBemerkungButton
                data={this.props.data}
                standort={this.props.standortTid}
                type='co2'
                styleProps={{ backgroundColor: '#686868', color: '#fff' }}
                noLabel={true}
            />
        );
    }

    renderEingabeButton(): JSX.Element {
        return (
            <WActionButton
                label={i18n('Dateneingabe', 'sys')}
                insideText={i18n('zur E-Tool Eingabe wechseln', 'sys')}
                tooltip={i18n('zur E-Tool Eingabe wechseln', 'sys')}
                key='dateneingabe'
                action='editNote'
                styleProps={{ color: 'var(--color-button-text)', backgroundColor: 'var(--color-section-main)' }}
                onAction={() => this.props.onRoutingChange({
                    ...(getRoutingCO2Scope3(this.props.data, this.props.standortTid)), key: 'inputScope3'
                })}
            />
        );
    }

    renderStandort(): JSX.Element {
        const disabled: boolean = this.props.data.MODUL_SELECTED === 'steuer';

        return (
            <StandortAuswahl
                label={i18n('Standort', 'sys')}
                data={this.props.data}
                standort={this.props.standortTid}
                disabled={disabled}
                filter={(standort: any, callback: (visible: boolean) => void) => {
                    const kennzahlen: any = (this.props.data[IDs.KENNZIFFERN_BERECHNET_STANDORT] || {})[standort.tid]
                        || this.props.data[IDs.KENNZIFFERN_BERECHNET] || {};
                    const flags: any = kennzahlen.flags || {};

                    if (typeof callback === 'function') {
                        callback(!!flags.hasCO2);
                    }
                }}
                onStandortChange={(standort: number) => {
                    const basisRouting: any = RoutingIDs.ROUTE_DATENAUSWERTUNG_STANDORTE;
                    const basisTab: string = RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE;
                    const tabRoutings: any[] = getStandorteGruppenTabRoutings(this.props.data, basisRouting, basisTab, 2);
                    const path: any = (tabRoutings.find((item: any) => item?.dataRow?.tid === standort) || {}).path || {};
                    this.props.onRoutingChange({ path: { ...RoutingIDs.ROUTE_CO2_FUSS_GESAMT, ...path } });
                }}
                renderClean
            />
        );
    }

    renderVeranstaltung(): JSX.Element {
        return <>
            <label>{i18n('Standort', 'sys')}</label>
            <input type='text' value={this.props.standortName} disabled />
        </>;
    }
}
